/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_FlagshipInputs */

const en_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ FLAGSHIP`)
};

const ar_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ رائد`)
};

const bn_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ ফ্ল্যাগশিপ`)
};

const de_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ FLAGGSCHIFF`)
};

const es_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ BUQUE INSIGNIA`)
};

const fr_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ PHARE`)
};

const pt_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ BANDEIRA`)
};

const zh_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ 旗舰`)
};

const tr_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ FLAGSHIP`)
};

const ru_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ ФЛАГМАН`)
};

const pl_svc_flagship = /** @type {(inputs: Svc_FlagshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`▲ FLAGOWY`)
};

/**
* | output |
* | --- |
* | "▲ FLAGSHIP" |
*
* @param {Svc_FlagshipInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_flagship = /** @type {((inputs?: Svc_FlagshipInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_FlagshipInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_flagship(inputs)
	if (locale === "bn") return bn_svc_flagship(inputs)
	if (locale === "de") return de_svc_flagship(inputs)
	if (locale === "es") return es_svc_flagship(inputs)
	if (locale === "fr") return fr_svc_flagship(inputs)
	if (locale === "pt") return pt_svc_flagship(inputs)
	if (locale === "zh") return zh_svc_flagship(inputs)
	if (locale === "tr") return tr_svc_flagship(inputs)
	if (locale === "ru") return ru_svc_flagship(inputs)
	if (locale === "pl") return pl_svc_flagship(inputs)
	return en_svc_flagship(inputs)
});